// assets/js/attire.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor = document.body.classList.contains("wp-admin");
if (!isEditor) gsap.registerPlugin(ScrollTrigger);

function initAttire(section) {
  if (!section || section.__attireInit) return;
  section.__attireInit = true;

  const eyebrow = section.querySelector(".attire__eyebrow");
  const headline = section.querySelector(".attire__headline");
  const intro = section.querySelector(".attire__intro");
  const photo = section.querySelector(".attire__photo figure");
  const img = section.querySelector(".attire__photo img");
  const items = section.querySelectorAll(".attire__item");

  gsap.set([eyebrow, headline, intro], { opacity: 0, y: 18 });
  if (photo) gsap.set(photo, { opacity: 0, y: 16 });
  if (img) gsap.set(img, { scale: 1.06 });
  if (items?.length) gsap.set(items, { opacity: 0, y: 14 });

  const tlOpts = isEditor
    ? { defaults: { ease: "power3.out" } }
    : {
        defaults: { ease: "power3.out" },
        scrollTrigger: { trigger: section, start: "top 78%", once: true },
      };

  const tl = gsap.timeline(tlOpts);

  if (eyebrow) tl.to(eyebrow, { opacity: 1, y: 0, duration: 0.45 });
  if (headline) tl.to(headline, { opacity: 1, y: 0, duration: 0.65 }, "-=0.2");
  if (intro) tl.to(intro, { opacity: 1, y: 0, duration: 0.55 }, "-=0.25");

  if (photo) {
    tl.to(photo, { opacity: 1, y: 0, duration: 0.55 }, "-=0.15");
    if (img) tl.to(img, { scale: 1, duration: 0.9, ease: "power2.out" }, "<");
  }

  if (items?.length) {
    tl.to(items, { opacity: 1, y: 0, duration: 0.5, stagger: 0.08 }, "-=0.25");
  }
}

const mount = () => {
  if (!isEditor) {
    document.querySelectorAll(".attire").forEach(initAttire);
    return;
  }

  const root = document.querySelector(".editor-styles-wrapper") || document;
  const run = () => root.querySelectorAll(".attire").forEach(initAttire);

  run();
  const mo = new MutationObserver(run);
  mo.observe(root, { childList: true, subtree: true });
};

if (window.wp?.domReady) window.wp.domReady(mount);
else document.addEventListener("DOMContentLoaded", mount);
